import IStepThreeModel from './IStepThreeModel';

const StepThreeModelInitialState: IStepThreeModel = {
  hasBimehNamehGhabl: true,
  sherkatBimehGhabl: null,
  shomarehBimehGhabl: null,
  tarikhEnghezaBimehGhabl: null,
};

export default StepThreeModelInitialState;
